module.exports = __webpack_public_path__ + "static/media/majorB7.9420f17.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorB7.wav
// module id = jY2c
// module chunks = 0